import MapAction from "./MapAction";

export class ShowHtmlTabMapAction extends MapAction {
    constructor(id, name, iconFilePath, htmlFilePath) {
        super(id, name, iconFilePath, "showHtml");
        this.htmlFilePath = htmlFilePath;
    }
}